import { default as getServiceWorkerPath } from './getServiceWorkerPath';
import { default as getRootVdirName } from './getRootVdirName';
import { trace } from 'owa-trace';

const SERVICEWORKER_FILENAME: string = 'sw_extension_webpush.js'; //TODO: change to sw_extension_webpush after servfer pr merge

export const SERVICEWORKER_SCOPE: string = '/webpush/'; //TODO: why??

export default async function registerWebPushServiceWorker(
    windowObj: Window
): Promise<ServiceWorkerRegistration> {
    const rootVdir = getRootVdirName(windowObj.location);
    const serviceWorkerPath = getServiceWorkerPath(rootVdir);
    const serviceworkerUrl =
        serviceWorkerPath != null
            ? `${serviceWorkerPath}/${SERVICEWORKER_FILENAME}`
            : `/${SERVICEWORKER_FILENAME}`;
    const options: RegistrationOptions = { scope: SERVICEWORKER_SCOPE };
    // tslint:disable-next-line:no-console
    console.log('registerWebPushServiceWorker.. ', rootVdir, serviceWorkerPath, serviceworkerUrl);
    return (
        windowObj.navigator.serviceWorker
            .register(serviceworkerUrl, options)
            .then((registration: ServiceWorkerRegistration) => {
                let worker = null;
                if (registration.installing != null) {
                    worker = registration.installing;
                } else if (registration.waiting != null) {
                    worker = registration.waiting;
                } else if (registration.active != null) {
                    worker = registration.active;
                }
                if (worker.state === 'activated') {
                    return registration;
                } else {
                    return new Promise<ServiceWorkerRegistration>((resolve, reject) => {
                        worker.onstatechange = function () {
                            if (worker.state === 'activated') {
                                worker.onstatechange = null;
                                return resolve(registration);
                            }
                        };
                    });
                }
            })
            .then((registration: ServiceWorkerRegistration) =>
                registration.update().then(() => registration)
            ) // Trigger explicit update as invoking register is not fetching new worker
            // This is most likely due to the worker registered to different path.
            .catch((e: Error) => {
                trace.warn('[WebPush] Service worker registraiton failed, error: ' + e.message);
                throw e;
            })
    );
}
